var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('HeaderBreadcrumbs', {
    attrs: {
      "items": [{
        label: 'SmartPin',
        to: {
          name: 'smartpininsight'
        }
      }, {
        label: 'Insight'
      }],
      "title": "Insight"
    }
  }), _c('div', {
    staticClass: "w-full border-gray-100 rounded-xl mb-5 p-0"
  }, [_c('div', {
    staticClass: "w-full bg-white p-4 shadow-sm rounded-xl"
  }, [_c('div', {
    staticClass: "flex items-center justify-between mb-6"
  }, [_c('h2', {
    staticClass: "text-xl font-bold text-gray-900 tracking-tight"
  }, [_vm._v(" Summary Onsite Reader ")]), _c('DateRangePicker', {
    attrs: {
      "max-days": 31
    },
    on: {
      "change": _vm.handleDateRangeChange
    },
    model: {
      value: _vm.selectedDateRange,
      callback: function ($$v) {
        _vm.selectedDateRange = $$v;
      },
      expression: "selectedDateRange"
    }
  })], 1), _c('div', {
    staticClass: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6"
  }, _vm._l(_vm.summaryCards, function (card, index) {
    return _c('div', {
      key: index,
      staticClass: "bg-white border h-36 border-gray-200 rounded-2xl p-4 flex flex-col justify-between hover:border-gray-300 transition-colors"
    }, [_c('div', {
      staticClass: "w-8 h-8 rounded-lg flex items-start justify-center mb-2",
      class: card.iconBg
    }, [card.type === 'location' ? _c('img', {
      attrs: {
        "src": require("../../assets/img/pin.png"),
        "alt": ""
      }
    }) : card.type === 'scan' ? _c('img', {
      attrs: {
        "src": require("../../assets/img/qrcode.png"),
        "alt": ""
      }
    }) : card.type === 'purchase' ? _c('img', {
      attrs: {
        "src": require("../../assets/img/purchase.png"),
        "alt": ""
      }
    }) : card.type === 'subscribe' ? _c('img', {
      attrs: {
        "src": require("../../assets/img/subcribe.png"),
        "alt": ""
      }
    }) : _vm._e()]), _c('div', [_c('p', {
      staticClass: "text-base text-gray-500 font-medium mb-1",
      class: {
        'underline text-blue-500 cursor-pointer': card.isLink
      }
    }, [_vm._v(" " + _vm._s(card.title) + " ")]), _c('h3', {
      staticClass: "text-2xl font-bold text-gray-900 leading-tight"
    }, [_vm._v(" " + _vm._s(card.value) + " ")])])]);
  }), 0)]), _c('div', {
    staticClass: "flex shadow-sm bg-white rounded-xl mt-3 h-auto p-4 w-full items-start justify-start flex-col space-y-8"
  }, [_c('SummaryInsightCharts', {
    attrs: {
      "is-loading-funnel": _vm.isLoadingFunnel,
      "is-loading-summary": _vm.isLoadingSummary,
      "awareness-metrics": _vm.awarenessMetrics,
      "awareness-series": _vm.awarenessSeries,
      "awareness-chart-options": _vm.awarenessChartOptions,
      "funnel-series": _vm.funnelSeries,
      "funnel-chart-options": _vm.funnelChartOptions,
      "raw-acquisition-values": _vm.rawAcquisitionValues
    }
  })], 1), _c('div', {
    staticClass: "grid p-0 rounded-xl pb-3 grid-cols-1 mt-3 lg:grid-cols-2 gap-6 w-full"
  }, [_c('div', {
    staticClass: "flex w-full flex-col bg-white rounded-xl p-4 shadow-sm"
  }, [_c('div', {
    staticClass: "w-full flex items-center justify-between px-0"
  }, [_c('div', {
    staticClass: "flex-col"
  }, [_c('h2', {
    staticClass: "text-xl mb-0 font-bold text-gray-900 tracking-tight"
  }, [_vm._v(" Top Locations ")]), _c('p', {
    staticClass: "text-xs text-gray-700"
  }, [_vm._v(_vm._s(_vm.formatDateRange(this.selectedDateRange)))])]), _c('div', [_c('router-link', {
    staticClass: "text-xs font-medium text-gray-900 hover:text-blue-600 hover:no-underline",
    attrs: {
      "to": _vm.topLocationDetailRoute
    }
  }, [_vm._v(" See more "), _c('i', {
    staticClass: "fa-solid fa-angle-right"
  })])], 1)]), _c('div', {
    staticClass: "w-full px-0"
  }, [_c('TopLocationsTable', {
    attrs: {
      "locations": _vm.topLocations,
      "is-loading": _vm.isLoadingTopLocations,
      "selected-date-range": _vm.selectedDateRange
    }
  })], 1)]), _c('div', {
    staticClass: "flex w-full flex-col bg-white rounded-xl p-4 shadow-sm"
  }, [_c('div', {
    staticClass: "w-full flex items-center justify-between px-0"
  }, [_c('div', {
    staticClass: "flex-col"
  }, [_c('h2', {
    staticClass: "text-xl mb-0 font-bold text-gray-900 tracking-tight"
  }, [_vm._v(" Top Content ")]), _c('p', {
    staticClass: "text-xs text-gray-700"
  }, [_vm._v(_vm._s(_vm.formatDateRange(this.selectedDateRange)))])]), _c('div', [_c('router-link', {
    staticClass: "text-xs font-medium text-gray-900 hover:text-blue-600 hover:no-underline",
    attrs: {
      "to": _vm.topContentDetailRoute
    }
  }, [_vm._v(" See more "), _c('i', {
    staticClass: "fa-solid fa-angle-right"
  })])], 1)]), _c('div', [_c('TopContentsTable', {
    attrs: {
      "contents": _vm.topContents,
      "is-loading": _vm.isLoadingTopContents,
      "selected-date-range": _vm.selectedDateRange
    }
  })], 1)])])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }